<template>
  <div class="app-content">
    <div
      v-if="isFirstPage === false && !hideBreadcrumb"
      id="breadcrumb"
      class="top-header"
    >
      <div style="display: flex; align-items: center; height: 100%">
        <Breadcrumb />
        <LeftMenu style="margin-left: 16px" mode="horizontal"></LeftMenu>
      </div>
      <TopHeader ref="topHeader"></TopHeader>
    </div>
    <div id="app-main" class="animated">
    <!-- <div id="app-main" class="animated fadeInRight"> -->
      <LeftMenu style="transform: translate(-20px, -10px); min-width: 140px; max-width: 140px; height: calc(100%);" v-show="isShowSideMenu"></LeftMenu>
      <div :style="contentStyle">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from './Breadcrumb'
import TopHeader from '@/components/layout/TopHeader'
import { mapState } from 'vuex'
import LeftMenu from '@/components/layout/LeftMenu.vue'

export default {
  name: 'AppMain',
  components: {
    Breadcrumb,
    TopHeader,
    LeftMenu,
  },
  computed: {
    contentStyle() {
      return {
        width: this.isShowSideMenu ? `calc(100vw - 180px)` : `calc(100vw - 40px)`,
      }
    },
    ...mapState({
      themeColor: (state) => state.common.themeColor,
      firstType: (state) => state.common.firstType,
    }),
    hideBreadcrumb() {
      return this.$route.meta && this.$route.meta.hideBreadcrumb
    },
    isShowSideMenu(){
      return [
        '/shop/shopManage',
        '/config/serviceFee/receiveAccount',
        '/config/serviceFee/rechargeManager',
        '/config/serviceFee/costBill',
        '/roomtype_manage', 
        '/housekeeper_distribution', 
        '/room_transfer', 
        '/sorting',
        '/system/common/users/index', 
        '/system/common/roles', 
        '/system/common/dictMng', 
        '/system/advance/systemParams', 
        '/system/dataPush', 
        '/system/pushDataLog',
        '/config/employee',
        "/system/auditConfig",
        "/system/log/operateLog",
        '/equip/doorLock',
        '/equip/doorBell',
        '/gateLockLog',
        '/OTA',
        '/firmwareManager',
        '/issuedLog',
        '/equip/whiteList',
        '/gateBellLog',
      ].includes(this.$route.path);
    }
  },
  data() {
    return {
      isFirstPage: false,
    }
  },
  created() {
    if (
      this.$route.path === '/actual' ||
      (this.$route.meta && this.$route.meta.hideBreadcrumb) ||
      this.$route.path === '/personManage/personTrail' ||
      this.$route.path === '/fullScreenMap'
    ) {
      this.isFirstPage = true
    }
  },
  mounted() {
    this.initSize()
    const _this = this
    $(window).resize(function (event) {
      _this.initSize()
    })
  },
  watch: {
    $route(to, from) {
      if (to.path === '/') {
        //this.isFirstPage = true
      } else {
        this.isFirstPage = false
      }
    },
    themeColor() {
      this.initSize()
    },
    firstType() {
      this.initSize()
    },
    isFirstPage() {
      this.initSize()
    },
  },
  methods: {
    initSize() {
      setTimeout(() => {
        let mainHeight = $('body').height() - $('#app-main').offset().top - 5 + 'px'
        $('#app-main').height(mainHeight)
      }, 20)
    },
  },
}
</script>

<style lang="less" scoped>
.animated{
  display: flex;
}
</style>